import {z} from 'zod';

import i18n from '@dms/i18n';

export const ClaraSendFormSchema = z
  .object({
    claimType: z.string().nonempty(),
    repairStartDate: z.string(),
    mileageStart: z.number().min(0),
    repairEndDate: z.string(),
    mileageEnd: z.number().min(0),
    partPurchaseDate: z.string().nullable().optional(),
    mileagePartPurchase: z.number().nullable().optional(),
    partNumber: z.string().nullable().optional(),
  })
  .superRefine((data, ctx) => {
    if (data.claimType === '1') {
      if (!data.partNumber) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          path: ['partNumber'],
          message: i18n.t('general.errors.mixed.required'),
        });
      }
      if (!data.partPurchaseDate) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          path: ['partPurchaseDate'],
          message: i18n.t('general.errors.mixed.required'),
        });
      }
      if (data.mileagePartPurchase == null) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          path: ['mileagePartPurchase'],
          message: i18n.t('general.errors.mixed.required'),
        });
      }
    }
  });

export type ClaraSendFormType = z.infer<typeof ClaraSendFormSchema>;
